import config from '@plone/volto/registry';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  bgcolor: {
    id: 'Background color',
    defaultMessage: 'Background color',
  },
});


export const BgColorSchema = ({ schema, formData, intl }) => {
  const defaultBGColor = config.blocks?.blocksConfig?.[formData['@type']]?.defaultBGColor;

  addStyling({ schema, intl });
  schema.properties.styles.schema.properties.bgcolor = {
    widget: 'color_picker',
    title: intl.formatMessage(messages.bgcolor),
    colors: config.settings.availableColors,
    default: defaultBGColor,
  };
  schema.properties.styles.schema.fieldsets[0].fields.push('bgcolor');

  return schema;
};
